// The admin screens plug into the admin shell by name, as the product screens do (src/product/screens.js),
// so each can be written without touching the shell. A screen is the default export of
// src/admin/screens/<Name>.jsx, 1 of shell/routes.js's SCREEN_NAMES:
//
//   Today, People, Person, Masterminds, Products, AddProduct, Product, Layout, Recordings, Webinars,
//   Resources, Prices, Referrals, Reports, Audit
//
// It's drawn inside the shell (the menu, the view-as bar, the flash) and given:
//
//   me      useMember()'s me: me.who (whoami: person_id, staff_role ...) and me.person (their own row)
//   role    'owner' | 'admin' | 'support' | 'host'
//   route   { screen, params, parts, path }: params.id (a person, a webinar), params.slug (a product),
//           params.tab ('recordings' | 'dates') and params.rest, params.report (shell/routes.js)
//   api     src/admin/api.js's adminApi(me): every staff read and write by its contract name
//   scopes  a host's product ids (empty for everyone else)
//
// It draws its own page: <PageHeader> and the rest of src/admin/ui. Until its file exists the route
// draws a holding panel with the screen's title.

import { SCREEN_NAMES } from './shell/routes.js'

const found = new Map()

// The screen's default export, or null. Every file under src/admin/ is in the bundle (esbuild bundles
// the folder for this import), so this resolves at once; the answer is kept.
export async function loadAdminScreen(name) {
  if (!SCREEN_NAMES.includes(name)) return null
  if (found.has(name)) return found.get(name)
  let screen = null
  try {
    // the folder is part of the variable, so the build needs no file in src/admin/screens/ yet
    const file = ['screens', name].join('/')
    const mod = await import(`./${file}.jsx`)
    screen = typeof mod?.default === 'function' ? mod.default : null
  } catch {
    screen = null
  }
  found.set(name, screen)
  return screen
}

// The answer already kept for a name: the screen, null (no file), or undefined (not asked yet)
export function knownAdminScreen(name) {
  return found.has(name) ? found.get(name) : undefined
}
